module.exports = __webpack_public_path__ + "img/Slice201.2adf730e.png";